export const RangeShortcut = {
  twoYears: 'TWO_YEARS',
  oneYear: 'ONE_YEAR',
  yearToDate: 'YEAR_TO_DATE',
  sixMonths: 'SIX_MONTHS',
  threeMonths: 'THREE_MONTHS',
  oneMonth: 'ONE_MONTH',
} as const;
export type RangeShortcut = (typeof RangeShortcut)[keyof typeof RangeShortcut];

export const RANGE_SHORTCUT_LABEL_MAP = {
  [RangeShortcut.twoYears]: '2 years',
  [RangeShortcut.oneYear]: '1 year',
  [RangeShortcut.sixMonths]: '6 months',
  [RangeShortcut.threeMonths]: '3 months',
  [RangeShortcut.oneMonth]: '1 month',
  [RangeShortcut.yearToDate]: 'Year to date',
} as const;

export const defaultRangeShortcuts = [
  RangeShortcut.twoYears,
  RangeShortcut.oneYear,
  RangeShortcut.sixMonths,
  RangeShortcut.threeMonths,
  RangeShortcut.oneMonth,
  RangeShortcut.yearToDate,
] as const satisfies RangeShortcut[];
